import React, { Fragment, useEffect } from 'react';

import { counterReducer, useCounterReducer, actionTypes  } from '@hooks/useCounter';


const InputWithLRBtn = props => {
    const {
        inputData: {
            id,
            isInputRequired,
            outerClass,
            name,
            placeholder,
            type,
            value
        },
        inputActions: {
            handleFieldChange
        },
        label: {
            text,
            labelClasses,
            ariaLabel,
        },
        button : {
            btnLId,
            btnRId,
            lBtnText,
            rBtnText,
            minCounter,
            maxCounter,
            btnClasses
        }
    } = props;


    const [ { counter }, dispatch ] = useCounterReducer(
        counterReducer, 
        { counter: value, minCounter, maxCounter }
    );

    useEffect(() => {
        handleFieldChange(counter);
    },[ counter ]);

    const handleCounterClick = (...args) => {
        const [ event, action ] = args;
        event.preventDefault();
        dispatch(action);
    };

    return (
        <Fragment>
            <div className={`gi-component gi-${type} ${outerClass && outerClass.join(' ')}`}>
                <button
                    id={`left_${btnLId}`}
                    data-testid = { `left_${btnLId}` }
                    className={`${btnClasses && btnClasses} usa-button gi-button gi-button__primary btn--left`}
                    onClick={e => handleCounterClick(e, { type: actionTypes.DECREMENT })}
                    disabled={counter <= minCounter}
                >{lBtnText}
                </button>
                <input
                    id={id}
                    className={`gi-${type}-input`}
                    data-testid = { id }
                    name={name}
                    type="text"
                    value={counter}
                    aria-required={isInputRequired}
                    placeholder={placeholder}
                    onChange={e => handleCounterClick(e, { type: actionTypes.MANUAL, counter: e.target.value } )}
                    aria-labelledby={name}
                />
                <button
                    id={`right_${btnRId}`}
                    data-testid = { `right_${btnRId}` }
                    className={`${btnClasses && btnClasses} usa-button gi-button gi-button__primary btn--right`}
                    onClick={e => handleCounterClick(e, { type: actionTypes.INCREMENT })}
                    disabled = {counter >= maxCounter}
                >{rBtnText}
                </button>
            </div>
        </Fragment>
    );
};
export default InputWithLRBtn;
